// client/src/pages/marketerpages/MarketerMybiz.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import MarketerBizHeader from '../../components/marketer/MarketerBizHeader';
import MarketerSidebar from '../../components/marketer/MarketerSidebar'; // New Sidebar
import MarketerTabbar from '../../components/marketer/MarketerTabbar';
import MarketerSecbar from '../../components/marketer/MarketerSecbar';
import { PointProvider } from '../../contexts/PointContext';

// Import CSS
import '../../styles/marketer/mb-layout.css';
import '../../styles/marketer/mb-forms.css';
import '../../styles/marketer/mb-tables.css';
import '../../styles/marketer/mb-ui.css';
import '../../styles/marketer/mb-modal.css';

// 하위 화면 컴포넌트
import MarketerBizHome from '../../components/marketer/MarketerBizHome';
import MarketerPwChange from '../../components/marketer/MarketerPwChange';
import MarketerMyInfoCheck from '../../components/marketer/MarketerMyInfoCheck';
import MarketerPointCharge from '../../components/marketer/MarketerPointCharge';
import MarketerPointCheck from '../../components/marketer/MarketerPointCheck';
import MarketerPointRefund from '../../components/marketer/MarketerPointRefund';

// 신규 섹션 컴포넌트
import MarketerProjectCreate from '../../components/marketer/MarketerProjectCreate';
import MarketerProjectInfluencerSelect from '../../components/marketer/MarketerProjectInfluencerSelect';
import MarketerProjectOnCheck from '../../components/marketer/MarketerProjectOnCheck';
import MarketerProjectResultCheck from '../../components/marketer/MarketerProjectResultCheck';
import MarketerProjectFinishCheck from '../../components/marketer/MarketerProjectFinishCheck';
import MarketerProjectCPSCharge from '../../components/marketer/MarketerProjectCPSCharge';
import MarketerInquiryCheck from '../../components/marketer/MarketerInquiryCheck';
import MarketerInquiryFinish from '../../components/marketer/MarketerInquiryFinish';
import MarketerInfluencerStats from '../../components/marketer/MarketerInfluencerStats';

function MarketerMybiz() {
	const nav = useNavigate();
	const location = useLocation();

	// 사이드바 상태 (모바일용)
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);
	
	// 활성 탭/서브메뉴 상태
	const [activeSub, setActiveSub] = useState(null); 

	// 접근 가드(광고주만)
	useEffect(() => {
		let ignore = false;
		(async () => {
			try {
				const res = await fetch('/api/user/me', { credentials: 'include' });
				const data = await res.json().catch(() => ({}));
				if (!res.ok || !data.ok || data.role !== 'marketer') {
					if (!ignore) nav('/');
					return;
				}
			} catch {
				if (!ignore) nav('/');
				return;
			}
		})();
		return () => { ignore = true; };
	}, [nav]);

	// ✅ URL 쿼리 파라미터와 상태 동기화 (URL 변경 시마다 실행)
	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const sub = params.get('sub');
		if (sub) {
			setActiveSub(sub);
		} else {
			setActiveSub(null);
		}
		// 탭 변경 시 사이드바 닫기 (모바일)
		setIsSidebarOpen(false);
	}, [location.search]);

	// ✅ 조건부 렌더링을 위한 컴포넌트 렌더 함수
	const renderComponent = () => {
		switch (activeSub) {
			// 0. 비즈 홈
			case 'home': return <MarketerBizHome />;

			// 1. 내정보 관리
			case 'password': return <MarketerPwChange />;
			case 'myInfo': return <MarketerMyInfoCheck />;
			
			// 2. 포인트 관리
			case 'pointCharge': return <MarketerPointCharge />;
			case 'pointList': return <MarketerPointCheck />;
			case 'pointRefund': return <MarketerPointRefund />;
			
			// 3. 광고 프로젝트
			case 'prjCreate': return <MarketerProjectCreate />;
			case 'prjSelect': return <MarketerProjectInfluencerSelect />;
			case 'prjOn': return <MarketerProjectOnCheck />;
			case 'prjResult': return <MarketerProjectResultCheck />;
			case 'prjFinish': return <MarketerProjectFinishCheck />;
			case 'prjCpsCharge': return <MarketerProjectCPSCharge />;
			case 'prjInfluencerStats': return <MarketerInfluencerStats />;
			
			// 4. 진행중인 문의 보기
			case 'inqOn': return <MarketerInquiryCheck />;
			case 'inqFinish': return <MarketerInquiryFinish />;
			
			// 기본 진입 화면 = 비즈 홈
			default: return <MarketerBizHome />;
		}
	};

	return (
		<PointProvider userRole="marketer">
			<div className="mb-layout-container">
				{/* Header - onMenuClick prop 전달하여 햄버거 메뉴 제어 */}
				<MarketerBizHeader onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} />
				
				{/* Sidebar */}
				<MarketerSidebar 
					isOpen={isSidebarOpen} 
					onClose={() => setIsSidebarOpen(false)} 
				/>

				{/* Main Content */}
				<main className="mb-main-content">
					{/* 컨텍스트 칩바 (모바일 2차 내비) */}
					<MarketerSecbar />
					{renderComponent()}
				</main>

				{/* Mobile Bottom Tabbar */}
				<MarketerTabbar />

				{/* Mobile Sidebar Overlay */}
				{isSidebarOpen && (
					<div 
						style={{
							position: 'fixed',
							top: 0, left: 0, right: 0, bottom: 0,
							backgroundColor: 'rgba(0,0,0,0.5)',
							zIndex: 1044 /* 드로어(1045) 바로 아래, 탭바(1040) 위 */
						}}
						onClick={() => setIsSidebarOpen(false)}
					/>
				)}
			</div>
		</PointProvider>
	);
}

export default MarketerMybiz;
